import React from "react";
import { iconArrowLeft } from "../../utils/svg_assets";
import "./style.scss";

export const DefaultLeading = ({ onClick = () => {} }) => (
  <div style={{ padding: "10px" }} onClick={onClick}>
    <img
      src={iconArrowLeft}
      className="icon-left"
      alt="arrow-back"
      width={24}
      height={24}
    />
  </div>
);

const HeaderLayout = ({
  title,
  leading = <div></div>,
  border = true,
  actions = <div></div>,
}) => {
  const innerStyle = {
    borderBottom: "1px solid #ebebeb",
  };

  return (
    <div
      className="top-navigation"
      style={border ? innerStyle : { boxShadow: "none" }}
    >
      <div className="left-navigation">{leading}</div>
      <div className="title-page">{title}</div>
      <div className="right-navigation">{actions}</div>
    </div>
  );
};

export default HeaderLayout;
